export const RATE_GROUPS_SET = 'RATE_GROUPS_SET';
